import { render, staticRenderFns } from "./packageType.vue?vue&type=template&id=612b5f66&scoped=true"
import script from "./packageType.vue?vue&type=script&lang=js"
export * from "./packageType.vue?vue&type=script&lang=js"
import style0 from "./packageType.vue?vue&type=style&index=0&id=612b5f66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612b5f66",
  null
  
)

export default component.exports